import {
  resolveChatFollowupChannel,
  resolveChatFollowupTargetName,
} from './chatFollowupApi';

const pickFirstText = (...values) => {
  for (const value of values) {
    if (typeof value !== 'string' && typeof value !== 'number') continue;
    const text = String(value).trim();
    if (text) return text;
  }
  return '';
};

const appendQuery = (baseUrl, params = {}) => {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    const text = pickFirstText(value);
    if (text) search.set(key, text);
  });
  const query = search.toString();
  return query ? `${baseUrl}?${query}` : baseUrl;
};

export const resolveChatFollowupAnchorMessageId = (task = {}) =>
  pickFirstText(
    task?.anchorMessageId,
    task?.anchor_message_id,
    task?.messageId,
    task?.message_id,
    task?.sourceMessageId,
    task?.source_message_id,
    task?.targetMessageId,
    task?.target_message_id,
  );

export const resolveAdminChatFollowupTarget = (task = {}) => {
  const channel = resolveChatFollowupChannel(task);
  return {
    channel,
    artistId: pickFirstText(task?.artistId, task?.artist_id),
    eventId: pickFirstText(task?.eventId, task?.event_id, task?.event_uuid),
    threadId: pickFirstText(task?.threadId, task?.thread_id),
    messageId: resolveChatFollowupAnchorMessageId(task),
    targetName: resolveChatFollowupTargetName(task),
  };
};

export const buildAdminChatFollowupTargetUrl = (target = {}) => {
  const channel = String(target?.channel || '').trim().toLowerCase() || 'personal';
  if (channel === 'event') {
    if (target.eventId) {
      return appendQuery('/admin/workspaces/event-operations/event-chat', {
        event: target.eventId,
        view: 'chat',
        message: target.messageId,
      });
    }
    if (target.threadId) {
      return appendQuery('/admin/workspaces/event-operations/event-chat', {
        thread: target.threadId,
        view: 'chat',
        message: target.messageId,
      });
    }
    return '';
  }

  if (channel === 'group') {
    if (!target.threadId) return '';
    return appendQuery('/admin/workspaces/communications/group-chat', {
      thread: target.threadId,
      message: target.messageId,
    });
  }

  if (!target.artistId) return '';
  return appendQuery('/admin/workspaces/communications/artist-chat', {
    artistId: target.artistId,
    view: 'chat',
    message: target.messageId,
  });
};

export const openAdminChatFollowupTarget = ({
  task,
  currentChannel = '',
  navigate,
  openPersonal,
  openEvent,
  openGroup,
} = {}) => {
  const target = resolveAdminChatFollowupTarget(task);
  const channel = target.channel || 'personal';

  if (channel === currentChannel) {
    if (channel === 'personal' && typeof openPersonal === 'function') {
      return openPersonal(target);
    }
    if (
      channel === 'event' &&
      (target.eventId || target.threadId) &&
      typeof openEvent === 'function'
    ) {
      return openEvent(target);
    }
    if (channel === 'group' && target.threadId && typeof openGroup === 'function') {
      return openGroup(target);
    }
  }

  const url = buildAdminChatFollowupTargetUrl(target);
  if (url && typeof navigate === 'function') {
    navigate(url);
  }
  return undefined;
};
